module.exports = "<ng-container *ngIf=\"content | asyncTimer as row_content\">\n    <season-header [row$]=\"row_content\" [showCount]=\"true\" [fullCopy]=\"true\" [showSubhead]=\"true\" *ngIf=\"(row_content|meta); let meta\"></season-header>\n    <list [list]=\"row_content\" class=\"list-row {{(row_content|meta).slug}}\" [fancy]=\"true\"></list>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/season-container/season-container.component.html
// module id = 874
// module chunks = 2